import uploadToCDN from '@/requests/cloud-storage/uploadToCDN';
import { isPicsartUrl } from '@/utils/url/safeUrl';
import canvasImageToFile from './canvasImageToFile';

type UploadCanvasImageParams = {
  url: string;
  imageId: string;
};

/**
 * Upload a canvas image URL to CDN.
 * If already on Picsart servers, returns the URL directly.
 * Otherwise fetches and uploads to CDN.
 */
const uploadCanvasImage = async ({
  url,
  imageId,
}: UploadCanvasImageParams): Promise<string> => {
  if (isPicsartUrl(url)) {
    return url;
  }

  const file = await canvasImageToFile({ url, imageId });
  if (!file) {
    throw new Error(`Invalid URL for canvas image upload: ${url}`);
  }

  const cdnUrl = await uploadToCDN(file);
  if (!cdnUrl) {
    throw new Error(`Failed to upload canvas image to CDN: ${url}`);
  }

  return cdnUrl;
};

export default uploadCanvasImage;
